import { css } from '@emotion/react';

const PlotChartStyles = css`
    display: flex;

    .js-area-plot-chart-tile {
        width: 70%;
    }

    li {
        list-style: none;
    }

    .sr-only {
        display: none;
    }
`;

export default PlotChartStyles;
